/*** IMPORTS FROM imports-loader ***/
var jquery = require("jquery");
var moment = require("moment");

'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Month = require('./Month');

var _Month2 = _interopRequireDefault(_Month);

var _Shortcuts = require('./Shortcuts');

var _Shortcuts2 = _interopRequireDefault(_Shortcuts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @fileOverview ReactComponent for displaying the "popover" of a date picker.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author jzetlen
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @memberof component-datepicker
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @function PickerPopover
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The transient "popover" component that appears when editing one of the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * dates, and disappears when no longer editing. Displays a `Month` component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and `Shortcuts` component, and a close button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Fades in and out based on the value of the `showing` prop. Displays a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * `Month` component and a `Shortcuts` component and passes props to them.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Displays a"close button" that can execute a supplied handler. Visually
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * orients a "tip" element towards the DOM element returned by the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * `getTipTarget` function it receives as a prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **/

var PickerPopover = function (_Component) {
	_inherits(PickerPopover, _Component);

	function PickerPopover(props) {
		_classCallCheck(this, PickerPopover);

		// we need a ref for the outer element so we can use DOM methods to
		// determine its dimension and position. this function will be passed
		// as a `ref` callback to the outer div. we declare this member in the
		// constructor so that it can assign to `this`, and we don't have to
		// re-bind the function on every render.
		var _this = _possibleConstructorReturn(this, (PickerPopover.__proto__ || Object.getPrototypeOf(PickerPopover)).call(this, props));

		_this.assignOuterDiv = function (divElement) {
			_this._outerDiv = divElement;
			if (_this._outerDiv) {
				// the picker 'hides' by setting its opacity to 0, but if we
				// do not also set visibility to hidden, it will invisibly
				// overlay the page and trap click events.
				var outerStyle = _this._outerDiv.style;
				var setVisibilityHidden = function setVisibilityHidden() {
					outerStyle.visibility = 'hidden';
				};
				// this member actually triggers a transition, based on the
				// `showing` prop. first it sets visibility, and then it
				// sets opacity. the transitionTime specified in CSS does the
				// rest.
				_this.showHide = function () {
					if (_this.props.showing) {
						outerStyle.visibility = 'visible';
						outerStyle.opacity = '1';
					} else {
						outerStyle.opacity = '0';
						// only after the fade out is complete, set
						// visibility to hidden so it's not an invisible,
						// overlaid div trapping clicks.
						setTimeout(setVisibilityHidden, _this.props.transitionTime);
					}
				};
			}
		};

		return _this;
	}
	// only trigger onShow and onHide events after the transition is
	// complete. this is simpler than using `animationEnd` events, because
	// we already have access to the transition time as a prop.


	_createClass(PickerPopover, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(_ref) {
			var showing = _ref.showing,
			    onShow = _ref.onShow,
			    onHide = _ref.onHide,
			    transitionTime = _ref.transitionTime;

			if (showing && !this.props.showing && onShow) {
				setTimeout(onShow, transitionTime || this.props.transitionTime);
			} else if (!showing && this.props.showing && onHide) {
				setTimeout(onHide, transitionTime || this.props.transitionTime);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _style;

			var classList = ['date-picker-wrapper'];
			if (this.props.popoverClassName) {
				classList.push(this.props.popoverClassName);
			}
			var closeButtonClassList = ['apply-btn'];
			if (this.props.closeButtonClassName) {
				closeButtonClassList.push(this.props.closeButtonClassName);
			}
			// the below style is specified inline because it is all strictly
			// necessary for the popover to work correctly.
			var transitionProp = 'opacity ' + this.props.transitionTime + 'ms';
			var style = (_style = {
				position: 'absolute'
			}, _defineProperty(_style, this.props.rtl ? 'right' : 'left', 0), _defineProperty(_style, 'top', '150%'), _defineProperty(_style, 'visibility', 'hidden'), _defineProperty(_style, 'overflow', 'visible'), _defineProperty(_style, 'opacity', '0'), _defineProperty(_style, 'WebkitUserSelect', 'none'), _defineProperty(_style, 'transition', transitionProp), _defineProperty(_style, 'WebkitTransition', transitionProp), _defineProperty(_style, 'MsTransition', transitionProp), _defineProperty(_style, 'MozTransition', transitionProp), _style);
			// set the outer div's style. on every `showing` render, it will be
			// 1, so a transition will only take place if `showing` has changed.
			// however, it needs to fully render before the style change triggers
			// a CSS transition, so we wait to run this method until render is
			// complete.
			if (this.showHide) {
				window.requestAnimationFrame(this.showHide);
			}

			// position the popover tip to the DOM element returned by the passed
			// `getTipTarget` function. the `DateRangerPicker` passes a function
			// that returns the DOM element of the currely editing input.
			var tipTarget = this.props.getTipTarget();
			var tipStyle = {};
			if (tipTarget && this._outerDiv) {
				var rect = tipTarget.getBoundingClientRect();
				var popoverRect = this._outerDiv.getBoundingClientRect();
				tipStyle.left = rect.left + rect.width / 2 - popoverRect.left;
			}

			return _react2.default.createElement(
				'div',
				{
					unselectable: 'on',
					ref: this.assignOuterDiv,
					style: style,
					className: classList.join(' ') },
				_react2.default.createElement('div', { style: tipStyle, className: 'date-picker-box-tip' }),
				_react2.default.createElement(
					'div',
					{ className: 'drp_top-bar normal' },
					_react2.default.createElement('input', {
						type: 'button',
						onClick: this.props.onClickClose,
						className: closeButtonClassList.join(' '),
						'aria-label': this.props.ariaLabel
					})
				),
				_react2.default.createElement(_Month2.default, this.props),
				_react2.default.createElement(_Shortcuts2.default, {
					shortcuts: this.props.shortcuts,
					onClickShortcut: this.props.onClickShortcut,
					active: this.props.getActiveShortcut()
				})
			);
		}
	}]);

	return PickerPopover;
}(_react.Component);

exports.default = PickerPopover;
var string = _react.PropTypes.string,
    bool = _react.PropTypes.bool,
    number = _react.PropTypes.number,
    func = _react.PropTypes.func,
    array = _react.PropTypes.array;

PickerPopover.propTypes = {
	showing: bool.isRequired,
	rtl: bool,
	transitionTime: number,
	popoverClassName: string,
	closeButtonClassName: string,
	onShow: func,
	onHide: func,
	onClickClose: func,
	shortcuts: array.isRequired,
	onClickShortcut: func,
	getActiveShortcut: func.isRequired,
	getTipTarget: func.isRequired,
	ariaLabel: string
};

PickerPopover.defaultProps = {
	transitionTime: 200
};



//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/component-datepicker/dist/components/PickerPopover.js
// module id = 782
// module chunks = 0